// import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
// import { stompService } from 'services/socketService';
// import { downloadAssetsFile, startDownloadAssets } from '../functions/download';
// import { startUploadAssets } from '../functions/Upload';
 
// /* ----------------------------------
//    HELPERS
// ---------------------------------- */
 
// const createTempId = () => `temp-${Date.now()}-${Math.random().toString(36).slice(2)}`;
 
// /* ----------------------------------
//    DOWNLOAD PROGRESS CONFIG
// ---------------------------------- */
 
// export const DOWNLOAD_PROGRESS = {
//   PREPARING: { start: 0, end: 10 },
//   PROCESSING: { start: 10, end: 20 },
//   DOWNLOADING: { start: 20, end: 99 },
//   DONE: { start: 99, end: 100 },
// };
 
// export const UPLOAD_PROGRESS = {
//   PREPARING: { start: 0, end: 10 },
//   UPLOADING: { start: 10, end: 85 },
//   PROCESSING: { start: 85, end: 95 },
//   DONE: { start: 95, end: 100 },
// };
 
// const DownloadAssetsContext = createContext(null);
 
// /* ----------------------------------
//    GENERIC PROGRESS MAPPER
// ---------------------------------- */
 
// const mapProgress = (phase, percent = 0, states = DOWNLOAD_PROGRESS) => {
//   const cfg = states[phase];
//   if (!cfg) return 0;
 
//   if (cfg.start === cfg.end) return cfg.end;
 
//   return Math.min(cfg.end, cfg.start + Math.floor(((cfg.end - cfg.start) * percent) / 100));
// };
 
// /* ==================================
//    PROVIDER
// ================================== */
 
// export const DownloadAssetsProvider = ({ children }) => {
//   const [downloadingAssets, setDownloadingAssets] = useState([]);
//   const [globalDownloadProgress, setGlobalDownloadProgress] = useState(0);
//   const [refreshRef, setrefreshRef] = useState(0);
 
//   const uploadListeners = useRef([]);
//   const uploadIdMapRef = useRef({});
//   const uploadMetaRef = useRef({});
 
//   /* ----------------------------------
//    SOCKET SUBSCRIPTION
// ---------------------------------- */
 
//   useEffect(() => {
//     const unsubscribe = stompService.subscribe('/user/topic/media.dam.final', (data) => {
//       uploadListeners.current.forEach((cb) =>
//         cb({
//           ...data,
//           activityId: data.activityId || data.uniqueId,
//         }),
//       );
 
//       handleDownloadSocket(data);
//       handleUploadSocket(data);
//     });
 
//     return () => unsubscribe?.();
//   }, []);
 
//   /* ----------------------------------
//    DOWNLOAD SOCKET HANDLER
// ---------------------------------- */
 
//   const handleDownloadSocket = async (data) => {
//     const { uniqueId, status } = data;
//     if (!uniqueId) return;
 
//     if (status === 'PREPARING') {
//       updateStatus(uniqueId, 'PREPARING', mapProgress('PREPARING', 100));
//       return;
//     }
 
//     if (status === 'PROCESSING') {
//       updateStatus(uniqueId, 'PROCESSING', mapProgress('PROCESSING', 100));
//       return;
//     }
 
//     if (status === 'READY') {
//       updateStatus(uniqueId, 'DOWNLOADING', mapProgress('DOWNLOADING', 0));
 
//       notify(uniqueId, 'DOWNLOADING', mapProgress('DOWNLOADING', 0), data);
 
//       try {
//         await downloadAssetsFile({ downloadId: uniqueId }, (downloadPercent) => {
//           const progress = mapProgress('DOWNLOADING', downloadPercent);
 
//           updateStatus(uniqueId, 'DOWNLOADING', progress);
//           notify(uniqueId, 'DOWNLOADING', progress, data);
//         });
 
//         updateStatus(uniqueId, 'DONE', DOWNLOAD_PROGRESS.DONE.end);
 
//         notify(uniqueId, 2, DOWNLOAD_PROGRESS.DONE.end, data);
 
//         cleanup(uniqueId);
//       } catch {
//         updateStatus(uniqueId, 'FAILED', 0);
//         notify(uniqueId, 'FAILED', 0, data);
//         cleanup(uniqueId);
//       }
 
//       return;
//     }
 
//     if (status === 'FAILED') {
//       updateStatus(uniqueId, 'FAILED', 0);
//       notify(uniqueId, 'FAILED', 0, data);
//       cleanup(uniqueId);
//     }
//   };
 
//   /* ----------------------------------
//    START DOWNLOAD
// ---------------------------------- */
 
//   const startDownload = async (payload , apiURL) => {
//     const job = await startDownloadAssets(payload , apiURL);
 
//     notify(job.downloadId, 'PREPARING', 0, {});
 
//     setDownloadingAssets((prev) => [
//       ...prev,
//       {
//         id: job.downloadId,
//         payload,
//         fileName: job.fileName,
//         status: 'PREPARING',
//         progress: mapProgress('PREPARING', 0),
//         showProgress: true,
//       },
//     ]);
//   };
 
//   /* ----------------------------------
//    STATE HELPERS
// ---------------------------------- */
 
//   const updateStatus = (id, status, progress = 0) => {
//     setDownloadingAssets((prev) => {
//       const updated = prev.map((d) =>
//         d.id === id ? { ...d, status, progress, showProgress: true } : d,
//       );
 
//       const active = updated.find((d) => d.status === 'DOWNLOADING');
 
//       setGlobalDownloadProgress(active ? active.progress : 0);
 
//       return updated;
//     });
//   };
 
//   const cleanup = (id) => {
//     setDownloadingAssets((prev) => {
//       const updated = prev.filter((d) => d.id !== id);
 
//       const active = updated.find((d) => d.status === 'DOWNLOADING');
 
//       setGlobalDownloadProgress(active ? active.progress : 0);
 
//       return updated;
//     });
//   };
 
//   /* ----------------------------------
//    LISTENER NOTIFIER
// ---------------------------------- */
 
//   const notify = (id, status, progress, data = {}) => {
//     const meta = uploadMetaRef.current[id] || {};
 
//     uploadListeners.current.forEach((cb) => {
//       cb({
//         ...data,
//         activityId: data.activityId || id,
//         status,
//         progress,
//         totalNumberOfAsset: meta.totalNumberOfAsset,
//         successCount: meta.successCount || 0,
//         showProgress: true,
//       });
//     });
//   };
 
//   /* ----------------------------------
//    REGISTER LISTENER
// ---------------------------------- */
 
//   const registerUploadListener = (cb) => {
//     uploadListeners.current.push(cb);
 
//     return () => {
//       uploadListeners.current = uploadListeners.current.filter((fn) => fn !== cb);
//     };
//   };
 
//   /* ----------------------------------
//    START UPLOAD
// ---------------------------------- */
 
//   const UploadFiles = async (formData, totalfiles , API_URL) => {
//     const tempId = createTempId();
 
//     uploadMetaRef.current[tempId] = {
//       totalNumberOfAsset: totalfiles,
//       successCount: 0,
//       lastCalculatedUploaded: 0,
//     };
 
//     notify(tempId, 'PREPARING', 0, {
//       uploadId: tempId,
//       isTemp: true,
//     });
 
//     try {
//       const job = await startUploadAssets(formData, (percent) => {
//         const mapped = mapProgress('UPLOADING', percent, UPLOAD_PROGRESS);
 
//         const meta = uploadMetaRef.current[tempId];
//         if (!meta) return;
 
//         /* calculate uploaded files */
 
//         const uploadedFiles = Math.floor((percent / 100) * meta.totalNumberOfAsset);
 
//         if (uploadedFiles > meta.lastCalculatedUploaded) {
//           const diff = uploadedFiles - meta.lastCalculatedUploaded;
 
//           meta.successCount += diff;
//           meta.lastCalculatedUploaded = uploadedFiles;
//         }
 
//         notify(tempId, 'UPLOADING', mapped);
//       } , API_URL);
 
//       uploadIdMapRef.current[job.uploadId] = tempId;
 
//       uploadMetaRef.current[job.uploadId] = uploadMetaRef.current[tempId];
 
//       notify(tempId, 'SWAP', 0, {
//         action: 'SWAP',
//         oldId: tempId,
//         newId: job.uploadId,
//       });
 
//       return job;
//     } catch (err) {
//       notify(tempId, 'FAILED', 0);
 
//       delete uploadMetaRef.current[tempId];
 
//       throw err;
//     }
//   };
 
//   /* ----------------------------------
//    HANDLE UPLOAD SOCKET
// ---------------------------------- */
 
//   const handleUploadSocket = (data) => {
//     const { activityId: requestId, status, percent = 0 } = data;

    
 
//     if (!requestId) return;
 
//     const mappedId = requestId;
 
//     data = {
//       ...data,
//       showProgress: true,
//       progress: mapProgress(status, percent, UPLOAD_PROGRESS),
//     };
 
//     if (status === 1) {
//       notify(mappedId, 'PROCESSING', mapProgress('PROCESSING', 100, UPLOAD_PROGRESS), data);
 
//       return;
//     }
 
//     if (status === 2) {
//       const meta = uploadMetaRef.current[requestId];
//       uploadMetaRef.current[requestId] = {
//         ...uploadMetaRef.current[requestId],
//         Responsecount: uploadMetaRef.current[requestId]?.Responsecount
//           ? uploadMetaRef.current[requestId].Responsecount + 1
//           : 1,
//       };
 
//       const remaining = meta.Responsecount ?  meta.Responsecount + 1 : 1;
 
//       if (meta.totalNumberOfAsset && remaining >= meta.totalNumberOfAsset) {
//         notify(mappedId, 2, UPLOAD_PROGRESS.DONE.end, data);
 
//         delete uploadMetaRef.current[requestId];
//         delete uploadIdMapRef.current[requestId];
 
//         setrefreshRef((p) => p + 1);
//       }
 
//       return;
//     }
 
//     if (status === 'FAILED') {
//       notify(mappedId, 'FAILED', 0, data);
 
//       delete uploadMetaRef.current[requestId];
//       delete uploadIdMapRef.current[requestId];
//     }
//   };
 
//   /* ----------------------------------
//    PROVIDER VALUE
// ---------------------------------- */


// /* ----------------------------------
//    PREVENT PAGE RELOAD/CLOSE
// ---------------------------------- */


// // useEffect(() => {
// //   // const hasActiveOperations = () => {
// //   //   // active downloads
// //   //   const activeDownloads = downloadingAssets.some(
// //   //     (item) =>
// //   //       item.status !== 'DONE' &&
// //   //       item.status !== 'FAILED'
// //   //   );

// //   //   // active uploads
// //   //   const activeUploads = Object.keys(uploadMetaRef.current).length > 0;

// //   //   return activeDownloads || activeUploads;
// //   // };

// //   const handleBeforeUnload = (e) => {
// //     if (globalDownloadProgress  >= 98) return;

// //     e.preventDefault();

// //     // Required for Chrome
// //     e.returnValue = '';
// //   };

// //   window.addEventListener('beforeunload', handleBeforeUnload);

// //   return () => {
// //     window.removeEventListener('beforeunload', handleBeforeUnload);
// //   };
// // }, [globalDownloadProgress]);
 
//   return (
//     <DownloadAssetsContext.Provider
//       value={{
//         startDownload,
//         downloadingAssets,
//         registerUploadListener,
//         globalDownloadProgress,
//         DOWNLOAD_PROGRESS,
//         UploadFiles,
//         UPLOAD_PROGRESS,
//         refreshRef,
//       }}
//     >
//       {children}
//     </DownloadAssetsContext.Provider>
//   );
// };
 
// /* ----------------------------------
//    HOOK
// ---------------------------------- */
 
// export const useDownloadAssets = () => {
//   const ctx = useContext(DownloadAssetsContext);
 
//   if (!ctx) {
//     throw new Error('useDownloadAssets must be used inside DownloadAssetsProvider');
//   }
 
//   return ctx;
// };
import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { stompService } from 'services/socketService';
import {
  downloadAssetsFile,
  startDownloadAssets,
  flushPendingBandwidth,
  hasActiveDownloads,
  cancelDownload as cancelDownloadRequest,
  cancelAllDownloads as cancelAllDownloadRequests,
  extensionOf,
  mapPhaseProgress,
  DOWNLOAD_PROGRESS,
  UPLOAD_PROGRESS,
} from '../functions/download';
import { startUploadAssets } from '../functions/Upload';

/* ----------------------------------
   HELPERS
---------------------------------- */

const createTempId = () => `temp-${Date.now()}-${Math.random().toString(36).slice(2)}`;

// how long we hold a socket event whose job we haven't claimed yet.
// covers the race where READY arrives before the POST promise resolves.
const ORPHAN_EVENT_TTL = 30_000;

// statuses during which a download can still be stopped
const CANCELLABLE_DOWNLOAD_STATUSES = ['PREPARING', 'PROCESSING', 'DOWNLOADING'];

/* ----------------------------------
   PROGRESS CONFIG

   These live in functions/download.js (breaks the old circular import).
   Re-exported here so existing imports from this module keep working.
---------------------------------- */

export { DOWNLOAD_PROGRESS, UPLOAD_PROGRESS };

const DownloadAssetsContext = createContext(null);

const mapProgress = mapPhaseProgress;

/* ==================================
   PROVIDER
================================== */

export const DownloadAssetsProvider = ({ children }) => {
  const [downloadingAssets, setDownloadingAssets] = useState([]);
  const [globalDownloadProgress, setGlobalDownloadProgress] = useState(0);
  const [refreshRef, setrefreshRef] = useState(0);

  const uploadListeners = useRef([]);
  const uploadIdMapRef = useRef({});
  const uploadMetaRef = useRef({});

  /* ----------------------------------
     JOB OWNERSHIP

     /user/topic/... is a *user* destination: Spring fans it out to EVERY
     STOMP session of that principal — every tab AND every device on the same
     login. Only the session that created the job may act on it.
  ---------------------------------- */

  const ownedDownloadsRef = useRef(new Set());
  const ownedUploadsRef = useRef(new Set());
  const earlyEventsRef = useRef(new Map()); // downloadId -> [event, ...]
  const orphanTimersRef = useRef(new Map()); // downloadId -> timeout id
  const refreshTimerRef = useRef(null);

  // real file name / type per download, filled in from response headers
  const downloadMetaRef = useRef({});

  // refs so the socket callback (registered once) always sees current logic
  const handleDownloadSocketRef = useRef(null);
  const handleUploadSocketRef = useRef(null);

  /* ----------------------------------
     SOCKET SUBSCRIPTION
  ---------------------------------- */

  useEffect(() => {
    const unsubscribe = stompService.subscribe('/user/topic/media.dam.final', (data) => {
      handleDownloadSocketRef.current?.(data);
      handleUploadSocketRef.current?.(data);
    });

    return () => unsubscribe?.();
  }, []);

  useEffect(
    () => () => {
      orphanTimersRef.current.forEach((t) => clearTimeout(t));
      orphanTimersRef.current.clear();
      if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current);
    },
    [],
  );

  /* ----------------------------------
     DEBOUNCED LIST REFRESH
  ---------------------------------- */

  const scheduleRefresh = () => {
    if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current);
    refreshTimerRef.current = setTimeout(() => {
      refreshTimerRef.current = null;
      setrefreshRef((p) => p + 1);
    }, 500);
  };

  /* ----------------------------------
     LISTENER NOTIFIER
  ---------------------------------- */

  const notify = (id, status, progress, data = {}) => {
    const meta = uploadMetaRef.current[id] || {};

    uploadListeners.current.forEach((cb) => {
      cb({
        ...data,
        activityId: data.activityId || id,
        status,
        progress,
        totalNumberOfAsset: meta.totalNumberOfAsset,
        // an explicit count wins: during upload this is bytes-derived, but once the
        // server starts confirming assets the caller passes the confirmed tally
        successCount: data.successCount ?? meta.successCount ?? 0,
        showProgress: true,
      });
    });
  };

  /* ----------------------------------
     DOWNLOAD NOTIFIER

     fileName/fileType come from whatever we actually know:
       1. the name the server sent in content-disposition (best)
       2. a fileName in the job/socket payload
       3. a neutral placeholder — never a guessed extension
  ---------------------------------- */

  const notifyDownload = (id, status, progress, data = {}) => {
    const meta = downloadMetaRef.current[id] || {};
    const fileName = data.fileName || meta.fileName || '';

    notify(id, status, progress, {
      ...data,
      activityId: id,
      kind: 'download',
      fileName: fileName || 'Preparing download…',
      fileType: meta.fileType || extensionOf(fileName) || '',
      cancellable: CANCELLABLE_DOWNLOAD_STATUSES.includes(status),
    });
  };

  /* ----------------------------------
     DOWNLOAD SOCKET HANDLER
  ---------------------------------- */

  const handleDownloadSocket = async (data) => {
    const { uniqueId, status } = data;
    if (!uniqueId) return;

    if (!ownedDownloadsRef.current.has(uniqueId)) {
      // It may still become ours — the POST that returns downloadId might not
      // have resolved yet. Buffer it instead of acting on it.
      const list = earlyEventsRef.current.get(uniqueId) || [];
      list.push(data);
      earlyEventsRef.current.set(uniqueId, list);

      if (!orphanTimersRef.current.has(uniqueId)) {
        const timer = setTimeout(() => {
          // nobody claimed it -> belongs to another session, drop it
          earlyEventsRef.current.delete(uniqueId);
          orphanTimersRef.current.delete(uniqueId);
        }, ORPHAN_EVENT_TTL);

        orphanTimersRef.current.set(uniqueId, timer);
      }

      return;
    }

    // remember a server-supplied name if the socket carries one
    if (data.fileName) {
      downloadMetaRef.current[uniqueId] = {
        ...downloadMetaRef.current[uniqueId],
        fileName: data.fileName,
        fileType: extensionOf(data.fileName),
      };
    }

    if (status === 'PREPARING') {
      updateStatus(uniqueId, 'PREPARING', mapProgress('PREPARING', 100));
      notifyDownload(uniqueId, 'PREPARING', mapProgress('PREPARING', 100), data);
      return;
    }

    if (status === 'PROCESSING') {
      updateStatus(uniqueId, 'PROCESSING', mapProgress('PROCESSING', 100));
      notifyDownload(uniqueId, 'PROCESSING', mapProgress('PROCESSING', 100), data);
      return;
    }

    if (status === 'READY') {
      updateStatus(uniqueId, 'DOWNLOADING', mapProgress('DOWNLOADING', 0));
      notifyDownload(uniqueId, 'DOWNLOADING', mapProgress('DOWNLOADING', 0), data);

      // fires mid-transfer, as soon as content-disposition is readable
      const handleMeta = ({ fileName, fileType }) => {
        downloadMetaRef.current[uniqueId] = {
          ...downloadMetaRef.current[uniqueId],
          fileName,
          fileType,
        };

        setDownloadingAssets((prev) =>
          prev.map((d) => (d.id === uniqueId ? { ...d, fileName, fileType } : d)),
        );
      };

      try {
        await downloadAssetsFile(
          { downloadId: uniqueId },
          (downloadPercent) => {
            const progress = mapProgress('DOWNLOADING', downloadPercent);

            updateStatus(uniqueId, 'DOWNLOADING', progress);
            notifyDownload(uniqueId, 'DOWNLOADING', progress, data);
          },
          handleMeta,
        );

        updateStatus(uniqueId, 'DONE', DOWNLOAD_PROGRESS.DONE.end);
        notifyDownload(uniqueId, 2, DOWNLOAD_PROGRESS.DONE.end, data);

        cleanup(uniqueId);
      } catch (err) {
        if (err.cancelled) {
          // cancelDownload() already pushed the CANCELLED row and cleaned up
          cleanup(uniqueId);
          return;
        }

        console.error('[download] failed for', uniqueId, err.status || '', err);

        updateStatus(uniqueId, 'FAILED', 0);
        notifyDownload(uniqueId, 'FAILED', 0, {
          ...data,
          error: err.message,
          statusCode: err.status,
        });
        cleanup(uniqueId);
      }

      return;
    }

    if (status === 'FAILED') {
      updateStatus(uniqueId, 'FAILED', 0);
      notifyDownload(uniqueId, 'FAILED', 0, data);
      cleanup(uniqueId);
    }
  };

  handleDownloadSocketRef.current = handleDownloadSocket;

  /* ----------------------------------
     START DOWNLOAD
  ---------------------------------- */

  const startDownload = async (payload, apiURL) => {
    const job = await startDownloadAssets(payload, apiURL);

    if (!job?.downloadId) {
      throw new Error('Failed to start download: missing downloadId');
    }

    // claim ownership BEFORE anything else async happens
    ownedDownloadsRef.current.add(job.downloadId);

    if (job.fileName) {
      downloadMetaRef.current[job.downloadId] = {
        fileName: job.fileName,
        fileType: extensionOf(job.fileName),
      };
    }

    notifyDownload(job.downloadId, 'PREPARING', mapProgress('PREPARING', 0), {
      fileName: job.fileName,
    });

    setDownloadingAssets((prev) => [
      ...prev,
      {
        id: job.downloadId,
        payload,
        fileName: job.fileName,
        status: 'PREPARING',
        progress: mapProgress('PREPARING', 0),
        showProgress: true,
        cancellable: true,
      },
    ]);

    // replay anything that arrived before we knew the id
    const buffered = earlyEventsRef.current.get(job.downloadId);
    if (buffered) {
      earlyEventsRef.current.delete(job.downloadId);

      const timer = orphanTimersRef.current.get(job.downloadId);
      if (timer) {
        clearTimeout(timer);
        orphanTimersRef.current.delete(job.downloadId);
      }

      buffered.forEach((e) => handleDownloadSocket(e));
    }

    // ONLY the HTTP-200 path is truly immediate. Gating on job.status here
    // would double-fire whenever the 202 body carries a ready-ish status, and
    // the second GET returns 410 Gone.
    if (job.immediate && !buffered?.length) {
      handleDownloadSocket({ uniqueId: job.downloadId, status: 'READY' });
    }

    return job;
  };

  /* ----------------------------------
     CANCEL DOWNLOAD
  ---------------------------------- */

  const cancelDownload = (id) => {
    if (!id) return;

    // aborts the XHR if a transfer is running, flags the job either way, and
    // hits the server-side cancel route if one is configured in download.js
    cancelDownloadRequest(id);

    updateStatus(id, 'CANCELLED', 0);
    notifyDownload(id, 'CANCELLED', 0, { cancelled: true });

    cleanup(id);
  };

  const cancelAllDownloads = () => {
    const ids = new Set([
      ...cancelAllDownloadRequests(),
      ...downloadingAssets.map((d) => d.id),
      ...ownedDownloadsRef.current,
    ]);

    ids.forEach((id) => cancelDownload(id));
  };

  /* ----------------------------------
     STATE HELPERS
  ---------------------------------- */

  const updateStatus = (id, status, progress = 0) => {
    setDownloadingAssets((prev) => {
      const updated = prev.map((d) =>
        d.id === id
          ? {
              ...d,
              status,
              progress,
              showProgress: true,
              cancellable: CANCELLABLE_DOWNLOAD_STATUSES.includes(status),
            }
          : d,
      );

      const active = updated.find((d) => d.status === 'DOWNLOADING');

      setGlobalDownloadProgress(active ? active.progress : 0);

      return updated;
    });
  };

  const cleanup = (id) => {
    ownedDownloadsRef.current.delete(id);
    earlyEventsRef.current.delete(id);

    const timer = orphanTimersRef.current.get(id);
    if (timer) {
      clearTimeout(timer);
      orphanTimersRef.current.delete(id);
    }

    // keep the name around briefly so a CANCELLED/FAILED row stays labelled
    setTimeout(() => {
      delete downloadMetaRef.current[id];
    }, 60_000);

    setDownloadingAssets((prev) => {
      const updated = prev.filter((d) => d.id !== id);

      const active = updated.find((d) => d.status === 'DOWNLOADING');

      setGlobalDownloadProgress(active ? active.progress : 0);

      return updated;
    });
  };

  /* ----------------------------------
     REGISTER LISTENER
  ---------------------------------- */

  const registerUploadListener = (cb) => {
    uploadListeners.current.push(cb);

    return () => {
      uploadListeners.current = uploadListeners.current.filter((fn) => fn !== cb);
    };
  };

  /* ----------------------------------
     START UPLOAD
  ---------------------------------- */

  const UploadFiles = async (formData, totalfiles, API_URL) => {
    const tempId = createTempId();

    uploadMetaRef.current[tempId] = {
      totalNumberOfAsset: totalfiles,
      successCount: 0,
      lastCalculatedUploaded: 0,
      Responsecount: 0,
    };

    notify(tempId, 'PREPARING', 0, {
      uploadId: tempId,
      isTemp: true,
      kind: 'upload',
    });

    try {
      const job = await startUploadAssets(
        formData,
        (percent) => {
          const mapped = mapProgress('UPLOADING', percent, UPLOAD_PROGRESS);

          const meta = uploadMetaRef.current[tempId];
          if (!meta) return;

          /* calculate uploaded files */
          const uploadedFiles = Math.floor((percent / 100) * meta.totalNumberOfAsset);

          if (uploadedFiles > meta.lastCalculatedUploaded) {
            const diff = uploadedFiles - meta.lastCalculatedUploaded;

            meta.successCount += diff;
            meta.lastCalculatedUploaded = uploadedFiles;
          }

          notify(tempId, 'UPLOADING', mapped, { kind: 'upload' });
        },
        API_URL,
      );

      // claim this upload for THIS session only
      ownedUploadsRef.current.add(job.uploadId);

      uploadIdMapRef.current[job.uploadId] = tempId;

      // same object reference, now reachable under the real id
      uploadMetaRef.current[job.uploadId] = uploadMetaRef.current[tempId];

      notify(tempId, 'SWAP', 0, {
        action: 'SWAP',
        oldId: tempId,
        newId: job.uploadId,
        kind: 'upload',
      });

      return job;
    } catch (err) {
      notify(tempId, 'FAILED', 0, { kind: 'upload' });

      delete uploadMetaRef.current[tempId];

      throw err;
    }
  };

  /* ----------------------------------
     HANDLE UPLOAD SOCKET
  ---------------------------------- */

  const handleUploadSocket = (data) => {
    const requestId = data.activityId || data.uniqueId;
    const { status, percent = 0 } = data;

    if (!requestId) return;

    const meta = uploadMetaRef.current[requestId];

    // Not our upload (fan-out from another session). Don't touch progress state
    // and don't crash on missing meta — just keep this tab's asset list fresh.
    if (!meta || !ownedUploadsRef.current.has(requestId)) {
      if (status === 2) scheduleRefresh();
      return;
    }

    const enriched = {
      ...data,
      activityId: requestId,
      kind: 'upload',
      showProgress: true,
      progress: mapProgress(status, percent, UPLOAD_PROGRESS),
    };

    // Fan out the raw event to listeners (previously done in the subscribe callback).
    // status 2 means ONE asset finished, not the activity — never let it through as
    // itself, or the UI marks the whole upload done on the first file. Completion is
    // decided below, once every asset has reported.
    uploadListeners.current.forEach((cb) =>
      cb(status === 2 ? { ...enriched, status: 1 } : enriched),
    );

    if (status === 1) {
      notify(requestId, 'PROCESSING', mapProgress('PROCESSING', 100, UPLOAD_PROGRESS), enriched);
      return;
    }

    if (status === 2) {
      // mutate in place — the old code replaced the object, leaving `meta` stale
      meta.Responsecount = (meta.Responsecount || 0) + 1;

      const totalAssets = meta.totalNumberOfAsset || 0;

      // Count the events we've actually received rather than trusting any count
      // carried in the payload, so this holds whether the server sends
      // increaseSuccessCount as a per-file increment or a running total.
      if (!totalAssets || meta.Responsecount < totalAssets) {
        const { start, end } = UPLOAD_PROGRESS.PROCESSING;
        const ratio = totalAssets ? meta.Responsecount / totalAssets : 0;

        notify(requestId, 'PROCESSING', start + Math.floor((end - start) * ratio), {
          ...enriched,
          status: 'PROCESSING',
          successCount: meta.Responsecount,
        });

        return;
      }

      notify(requestId, 2, UPLOAD_PROGRESS.DONE.end, {
        ...enriched,
        successCount: meta.Responsecount,
      });

      const tempId = uploadIdMapRef.current[requestId];
      if (tempId) delete uploadMetaRef.current[tempId];

      delete uploadMetaRef.current[requestId];
      delete uploadIdMapRef.current[requestId];
      ownedUploadsRef.current.delete(requestId);

      scheduleRefresh();

      return;
    }

    if (status === 'FAILED') {
      notify(requestId, 'FAILED', 0, enriched);

      const tempId = uploadIdMapRef.current[requestId];
      if (tempId) delete uploadMetaRef.current[tempId];

      delete uploadMetaRef.current[requestId];
      delete uploadIdMapRef.current[requestId];
      ownedUploadsRef.current.delete(requestId);
    }
  };

  handleUploadSocketRef.current = handleUploadSocket;

  /* ----------------------------------
     WARN ON CLOSE + FLUSH PARTIAL BANDWIDTH
  ---------------------------------- */

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      const downloadsActive =
        hasActiveDownloads() ||
        downloadingAssets.some(
          (d) => d.status !== 'DONE' && d.status !== 'FAILED' && d.status !== 'CANCELLED',
        );

      const uploadsActive = ownedUploadsRef.current.size > 0;

      if (!downloadsActive && !uploadsActive) return;

      // trigger the browser's "leave site?" confirmation
      e.preventDefault();
      e.returnValue = '';
      return '';
    };

    const handlePageHide = () => {
      // fires only when the page is genuinely being unloaded (not on cancel),
      // so reporting here won't double-count against normal completion
      flushPendingBandwidth();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('pagehide', handlePageHide);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, [downloadingAssets]);

  /* ----------------------------------
     PROVIDER VALUE
  ---------------------------------- */

  return (
    <DownloadAssetsContext.Provider
      value={{
        startDownload,
        cancelDownload,
        cancelAllDownloads,
        downloadingAssets,
        registerUploadListener,
        globalDownloadProgress,
        DOWNLOAD_PROGRESS,
        UploadFiles,
        UPLOAD_PROGRESS,
        refreshRef,
      }}
    >
      {children}
    </DownloadAssetsContext.Provider>
  );
};

/* ----------------------------------
   HOOK
---------------------------------- */

export const useDownloadAssets = () => {
  const ctx = useContext(DownloadAssetsContext);

  if (!ctx) {
    throw new Error('useDownloadAssets must be used inside DownloadAssetsProvider');
  }

  return ctx;
};